import { ChangeEvent } from "react";
import { Controller, ControllerRenderProps } from "react-hook-form";
import { Checkbox as MuiCheckbox, FormHelperText, FormLabel } from "@material-ui/core";

import useStyles from "../styles";

import { CheckboxProps } from "./checkbox.props";

export const Checkbox = (props: CheckboxProps) => {
  const { value = true } = props;

  const classes = useStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;

  const { required = false } = props;

  const onChange = (renderProps: ControllerRenderProps) => (e: ChangeEvent<HTMLInputElement>) =>
    renderProps.onChange(e.target.checked);

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={classes.fieldWrapper}>
          <MuiCheckbox
            {...renderProps.field}
            value={value}
            onChange={onChange(renderProps.field)}
          />
          <FormLabel component="span" error={hasError} required={required}>
            {props.label}
          </FormLabel>
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
